import React from 'react';
import Modal from 'react-bootstrap4-modal';

const CustomModal = (props) => {
  let { details, confirmBtn, cancelBtn, crossBtn, enableBackDrop, modalType, modalHeader, showBtns } = props;

  const headerBorderColor = modalType === 'danger' ? '#EF4444' : '#E2E8F0';
  const titleColor = modalHeader === 'danger' ? '#EF4444' : '#0F172A';

  return (
    <Modal visible={props.visibility} onClickBackdrop={enableBackDrop ? cancelBtn.action : null}>
      <div
        className="modal-content"
        style={{
          background: '#FFFFFF',
          border: '1px solid #E2E8F0',
          borderRadius: '24px',
          boxShadow: '0 25px 50px -12px rgba(15, 23, 42, 0.15)',
          overflow: 'hidden',
          animation: 'scaleIn 0.25s ease'
        }}
      >
        {/* Header */}
        <div
          className="modal-header"
          style={{
            background: '#FFFFFF',
            borderBottom: `1px solid ${headerBorderColor}`,
            padding: '1.5rem',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between'
          }}
        >
          <h5
            className="modal-title"
            style={{
              fontSize: '1.125rem',
              fontWeight: 700,
              color: titleColor,
              margin: 0,
              letterSpacing: '-0.02em'
            }}
          >
            {details.info}
          </h5>
          <button
            type="button"
            className="close"
            onClick={crossBtn.action}
            style={{
              background: 'transparent',
              border: 'none',
              width: 36,
              height: 36,
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '1.5rem',
              color: '#94A3B8',
              cursor: 'pointer',
              transition: 'all 150ms ease'
            }}
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        {/* Body */}
        <div className="modal-body" style={{ padding: '1.5rem' }}>
          {details.msg}
        </div>

        {/* Footer */}
        {showBtns && (
          <div
            className="modal-footer"
            style={{
              background: '#F8FAFC',
              borderTop: '1px solid #F1F5F9',
              padding: '1rem 1.5rem',
              display: 'flex',
              gap: '0.75rem',
              justifyContent: 'flex-end'
            }}
          >
            <button
              type="button"
              className="btn btn-theme-cancel"
              onClick={cancelBtn.action}
              style={{
                background: '#FFFFFF',
                color: '#475569',
                border: '1px solid #E2E8F0',
                borderRadius: '10px',
                padding: '0.625rem 1.25rem',
                fontWeight: 600,
                fontSize: '0.875rem',
                cursor: 'pointer',
                transition: 'all 150ms ease'
              }}
            >
              {cancelBtn.label}
            </button>
            <button
              type="button"
              className={modalType === 'danger' ? 'btn btn-danger' : 'btn btn-primary'}
              onClick={confirmBtn.action}
              style={{
                background: modalType === 'danger'
                  ? '#EF4444'
                  : 'linear-gradient(135deg, #6366F1 0%, #8B5CF6 100%)',
                color: 'white',
                border: 'none',
                borderRadius: '10px',
                padding: '0.625rem 1.25rem',
                fontWeight: 600,
                fontSize: '0.875rem',
                cursor: 'pointer',
                transition: 'all 150ms ease',
                boxShadow: modalType === 'danger'
                  ? '0 2px 8px rgba(239, 68, 68, 0.2)'
                  : '0 2px 8px rgba(99, 102, 241, 0.2)'
              }}
            >
              {confirmBtn.label}
            </button>
          </div>
        )}
      </div>
    </Modal>
  );
};

export default CustomModal;

CustomModal.defaultProps = {
  modalType: 'confirmation',
  visibility: true,
  showBtns: true,
  enableBackDrop: true,
  details: {
    info: 'N/A',
    msg: 'N/A'
  },
  crossBtn: {
    action: null
  },
  confirmBtn: {
    label: 'Confirm',
    action: null
  },
  cancelBtn: {
    label: 'Cancel',
    action: null
  }
};
